import './XpektorBootstrapModal.scss';
import { Modal } from 'react-bootstrap';

/* eslint-disable react/prop-types */
export default function TriggerModal({ trigger, handleClose }) {
  return (
    <Modal
      size="lg"
      show
      onHide={handleClose}
      backdrop="static"
      centered
      keyboard={false}
      className="border-0 xpektor-bootstrap-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{trigger.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {trigger.info && (
          <>
            <p>
              <b>Beskrivning:</b>
            </p>
            <p>{trigger.info}</p>
          </>
        )}
        {trigger.tips && (
          <>
            <p>
              <b>Åtgärder:</b>
            </p>
            <p>{trigger.tips}</p>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
